import { createContext, useContext } from "react";

const EditableContext = createContext<boolean>(true);
EditableContext.displayName = "EditableContext";
export const EditableProvider = EditableContext.Provider;

export const useEditable = () => useContext(EditableContext);
